import * as React from 'react';

import Tool16 from './Tool16';

export const tool16 = () => <Tool16 />;

export default {
    title: 'Icon/Line/Tool16',
    component: Tool16,
    parameters: {
        notes: "`import Tool16 from 'box-ui-elements/es/icon/line/Tool16';`",
    },
};
